import 'regenerator-runtime/runtime';
import '@onereach/styles/main-v3.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import * as VueCompositionAPI from '@vue/composition-api';
import { createPinia, PiniaVuePlugin } from 'pinia';

import AppLauncher from './AppLauncher.vue';
import { APP_LAUNCHER_ROUTES } from './constants';
import DEFAULT_TRANSLATIONS from '@/i18n/locales/en.json';

Vue.use(VueCompositionAPI.default);
Vue.use(VueRouter);

/* Vuex is a backwards compatibility feature */
Vue.use(Vuex);
Vue.use(PiniaVuePlugin);

/* Helpers are backwards compatibility feature from Action Desk */
Vue.prototype.$helpers = {};
Vue.prototype.$ORConfig = {};

Vue.config.devtools = HITL_ENABLE_VUE_DEVTOOLS;

/**
 * UI Next warnings cannot be fixed in Vue 2, so we hide these warning.
 * Also we should remove i18n warnings.
 */
Vue.config.warnHandler = (message, vm, trace) => {
  const OR_UI_WARNING = 'invalid prop: type check';
  const I18N_WARNING = 'vue-i18n';
  const isUIWarning = message.toLowerCase().includes(OR_UI_WARNING);
  const isI18nWarning = message.toLowerCase().includes(I18N_WARNING);

  if (isUIWarning || isI18nWarning) {
    return;
  }

  console.warn('[Vue Warn]: '.concat(message, trace));
};

/* UI bundles use these dependencies as a global variables */
(window as any).Vue = Vue;
(window as any).VueCompositionAPI = VueCompositionAPI;

const main = async () => {
  /* Should be provided before any async chunk to allow loading from localhost */
  __webpack_public_path__ = window.HITL_LAUNCHER_PUBLIC_PATH || __webpack_public_path__;

  const [{ install, i18n, applyDefaultMessages }] = await Promise.all([
    import(
      /* webpackChunkName: "actiondesk" */
      '@onereach/actiondesk-widgets-dispatcher'
    ),
    import(
      /* webpackChunkName: "actiondesk" */
      '@onereach/actiondesk-widgets-dispatcher/dist/auto/style.css'
    ),
  ]);

  /* Allow integration with Action Desk cards */
  install(Vue);
  applyDefaultMessages(DEFAULT_TRANSLATIONS);

  /* TODO: Replace with "createApp" in Vue 2.7 or Vue 3 */
  new Vue({
    el: '#app',
    pinia: createPinia(),
    i18n,
    store: new Vuex.Store({}),
    router: new VueRouter({ mode: 'history', routes: APP_LAUNCHER_ROUTES }),
    components: { AppLauncher },
    render(h) {
      return h(AppLauncher);
    },
  });
};

main();
